import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/settings/team", label: "Équipe", end: true },
  { to: "/settings/time-management", label: "Heures & Majoration", end: true },
];

const tabClassName = ({ isActive }) =>
  [
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium transition-colors no-underline",
    isActive ? "bg-gray-100 text-gray-900" : "text-gray-500 hover:text-gray-800",
  ].join(" ");

const SettingsTabs = () => (
  <nav
    className="flex flex-wrap gap-1 sm:gap-2"
    aria-label="Navigation paramètres entreprise"
  >
    {TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        className={tabClassName}
        end={tab.end}
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
);

export default SettingsTabs;
